const VENDOR_LOGOS = {
  abb: { src: "/images/equipment/logos/abb.png", name: "ABB", width: 644, height: 257 },
  visionnav: { src: "/images/equipment/logos/visionnav.png", name: "VisionNav Robotics", width: 298, height: 70 },
  bluepath: { src: "/images/equipment/logos/bluepath.png", name: "BluePath Robotics", width: 409, height: 123 },
  kuka: { src: "/images/equipment/logos/kuka.png", name: "KUKA", width: 360, height: 75 },
  otto: { src: "/images/equipment/logos/otto.png", name: "OTTO by Rockwell Automation", width: 400, height: 200 },
  seer: { src: "/images/equipment/logos/seer.png", name: "SEER Robotics", width: 360, height: 155 },
  wheelme: { src: "/images/equipment/logos/wheelme.png", name: "wheel.me", width: 360, height: 93 },
};

export default function VendorLogo({ slug, className }) {
  const logo = VENDOR_LOGOS[slug];
  if (!logo) return null;
  return (
    <img
      src={logo.src}
      alt={logo.name}
      width={logo.width}
      height={logo.height}
      className={className}
    />
  );
}
